import baseIcon from '../base.mjs';

const SiBuffer = baseIcon("Buffer", "#231F20", "M1.371 5.476L11.943 0l10.686 5.476-10.686 5.495zm3.36 4.81l7.212 3.547 7.288-3.547 3.398 1.655-10.686 5.202L1.371 11.94zm0 6.171l7.212 3.911 7.288-3.91 3.398 1.815L11.943 24 1.371 18.273z");
const SiBuffer$1 = SiBuffer;

export { SiBuffer$1 as default };
